import {Component, OnInit} from '@angular/core';
import {AccountTabsComponent} from '../../components/account-tabs/account-tabs.component';
import {HeaderComponent} from '../../components/header/header.component';
import {HelperBannerComponent} from '../../../core/components/helper-banner/helper-banner.component';
import {GiftCard, GiftCardStatus} from '../../../core/entities/gift-card/gift-card.entity';
import {GiftCardService} from '../../services/gift-card/gift-card.service';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {CurrencyPipe, DatePipe, NgClass} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-my-discounts',
  standalone: true,
  imports: [
    AccountTabsComponent,
    HeaderComponent,
    HelperBannerComponent,
    TranslocoPipe,
    CurrencyPipe,
    DatePipe,
    NgClass,
    RouterLink
  ],
  templateUrl: './my-discounts.component.html',
  styleUrl: './my-discounts.component.scss'
})
export class MyDiscountsComponent implements OnInit {
  public giftCards: GiftCard[] | null = null;
  public isLoading = false;
  protected readonly placeholders = [0, 1, 2];

  public constructor(
    private readonly giftCardService: GiftCardService,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
  ) {}

  public ngOnInit(): void {
    this.isLoading = true;
    this.giftCardService.getMyGiftCards().subscribe({
      next: (cards) => {
        this.giftCards = cards;
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error(
          this.transloco.translate('marketplace.discounts.error.content'),
          this.transloco.translate('marketplace.discounts.error.title'),
        );
        this.giftCards = [];
        this.isLoading = false;
      }
    });
  }

  public getStatusTagClass(status: GiftCard['status']): string {
    switch (status) {
      case GiftCardStatus.active:
        return 'tag--green';
      case GiftCardStatus.pending:
        return 'tag--orange';
      case GiftCardStatus.expired:
      case GiftCardStatus.depleted:
      case GiftCardStatus.disabled:
        return 'tag--red';
      default:
        return 'tag--blue';
    }
  }

  public trackByGiftCardId(_index: number, card: GiftCard): number {
    return card.id;
  }

  public copyCode(code: string): void {
    if (!code || typeof navigator === 'undefined' || !navigator.clipboard) {
      this.toastr.error(
        this.transloco.translate('marketplace.discounts.list.copy-error.content'),
        this.transloco.translate('marketplace.discounts.list.copy-error.title'),
      );
      return;
    }

    navigator.clipboard.writeText(code).then(
      () => {
        this.toastr.success(
          this.transloco.translate('marketplace.discounts.list.copy-success.content'),
          this.transloco.translate('marketplace.discounts.list.copy-success.title'),
        );
      },
      () => {
        this.toastr.error(
          this.transloco.translate('marketplace.discounts.list.copy-error.content'),
          this.transloco.translate('marketplace.discounts.list.copy-error.title'),
        );
      }
    );
  }
}
